import { articles, categories } from "@/mocks/gossip";

export type GossipArticle = (typeof articles)[number];
export type GossipCategory = (typeof categories)[number];

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)} 万`;
  }
  return `${heat}`;
}

export function getArticleById(id: string): GossipArticle | undefined {
  return articles.find((item) => item.id === id);
}

export function getCategoryById(id: string): GossipCategory | undefined {
  return categories.find((item) => item.id === id);
}

export function getArticlesByCategory(categoryId: string): GossipArticle[] {
  if (categoryId === "all") {
    return articles;
  }
  return articles.filter((item) => item.category === categoryId);
}

export function getRelatedArticles(article: GossipArticle, limit = 3): GossipArticle[] {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.category === article.category
  );
  const others = articles.filter(
    (item) => item.id !== article.id && item.category !== article.category
  );
  return [...sameCategory, ...others].slice(0, limit);
}